__turbopack_context__.v({
  "cardLinkLayer": "JKptBa_cardLinkLayer",
  "container": "JKptBa_container",
  "descriptionWithLists": "JKptBa_descriptionWithLists",
  "fullCardLink": "JKptBa_fullCardLink",
  "fullCardLinkIndicator": "JKptBa_fullCardLinkIndicator",
  "image": "JKptBa_image",
  "imageContainer": "JKptBa_imageContainer",
});
